import { action } from '@reatom/framework'

import { Result } from '@blade/std-lib'
import { CurrencyModel } from '@root/entities/currency'
import { Network } from '@root/entities/network'
import { reatomPair } from '@root/entities/pair'
import { reatomPremiumMeta } from '@root/entities/premium'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'

import type { PairModel } from '@root/entities/pair'
import type { DelugeId } from '@root/entities/user-short'

type DeployedTokensRequestParams = {
  network: Network.Network
  delugeId: DelugeId | undefined
  period: '1H' | '6H' | '12H' | '24H' | '7D' | '30D' | 'ALL'
}

export const deployedTokensRequestAction = action(
  async (ctx, params: DeployedTokensRequestParams) => {
    const {
      tradeApiClient,
      environment: {
        assets: { tokenLogosHost },
      },
    } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(() =>
      apiRequest(ctx, tradeApiClient.user.userProfileDeployedTokensList, [
        {
          network: Network.toDto(params.network),
          period: params.period,
          delugeId: params.delugeId,
        },
      ]),
    )

    return result.pipe(
      Result.map((dtos) =>
        dtos.map((dto) => {
          // eslint-disable-next-line @reatom/unit-naming-rule
          const pair: PairModel = reatomPair(
            dto,
            tokenLogosHost,
            // eslint-disable-next-line @reatom/unit-naming-rule
            reatomPremiumMeta({
              dto: dto.premiumInfo,
              currency: CurrencyModel.fromTokenMeta(dto.quote, tokenLogosHost),
            }),
          )

          return pair
        }),
      ),
      Result.mapError(ApiError.fallbackToUnknown),
    )
  },
  'deployedTokensRequestAction',
)
